"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationStatus = void 0;
exports.instanceOfCertificationStatus = instanceOfCertificationStatus;
exports.CertificationStatusFromJSON = CertificationStatusFromJSON;
exports.CertificationStatusFromJSONTyped = CertificationStatusFromJSONTyped;
exports.CertificationStatusToJSON = CertificationStatusToJSON;
exports.CertificationStatusToJSONTyped = CertificationStatusToJSONTyped;
/**
 *
 * @export
 */
exports.CertificationStatus = {
    Pending: 'PENDING',
    Completed: 'COMPLETED'
};
function instanceOfCertificationStatus(value) {
    for (const key in exports.CertificationStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.CertificationStatus, key)) {
            if (exports.CertificationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function CertificationStatusFromJSON(json) {
    return CertificationStatusFromJSONTyped(json, false);
}
function CertificationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CertificationStatusToJSON(value) {
    return value;
}
function CertificationStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=CertificationStatus.js.map